import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getQuizParticipants,
  getQuizParticipantsOld,
  getQuizStudents,
  getQuizzes,
  getRegisteredQuizUsersList,
  getUsersList,
} from "../redux/thunk";
import { setState } from "../redux/slice";
import CommonTable from "../../components/LawCollegeQuiz/CommonTable";

export default function UserManagement() {
  const dispatch = useDispatch();
  const {
    usersList,
    option_selected,
    quizzes,
    selectedQuizId,
    subFilterBy,
    filteredUsersList,
    liveParticipantsList,
    registeredList,
    practiceList,
  } = useSelector((state) => state.schoolQuizManagement);




  useEffect(() => {
    dispatch(getUsersList());
    // dispatch(getQuizzes("live"));
    dispatch(
      setState({
        key: "option_selected",
        value: 1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const fetchParticipants = async () => {
      if (!selectedQuizId) return;

      if (option_selected === 2) {
        console.log("srdd");
        await dispatch(getQuizParticipantsOld({ quiz_id: selectedQuizId, quiz_type: subFilterBy, }));
      } else if (option_selected === 3) {
        console.log("sr");
        await dispatch(getQuizParticipantsOld({ quiz_id: selectedQuizId, quiz_type: subFilterBy, }));
      }
    };

    fetchParticipants();
  }, [selectedQuizId, option_selected, dispatch]);

  console.log("quizzes", quizzes);

  const handleTabChange = async (value) => {
    dispatch(
      setState({
        key: "option_selected",
        value,
      })
    );
    dispatch(
      setState({
        key: "liveParticipantsList",
        value: [],
      })
    );
    dispatch(
      setState({
        key: "selectedQuizId",
        value: "",
      })
    );
    if (value === 2) {
      // DEFAULT LIVE → Academic (1)
      dispatch(setState({ key: "subFilterBy", value: 1 }));
      await dispatch(getQuizzes(1));
    }
    if (value === 3) {
      // DEFAULT PRACTICE → Academic (2)
      dispatch(setState({ key: "subFilterBy", value: 2 }));
      await dispatch(getQuizzes(2));
    }

  };
  const handleSubTabChange = async (value) => {
    dispatch(
      setState({
        key: "subFilterBy",
        value,
      })
    );
    if (value === 5) {
      await dispatch(getRegisteredQuizUsersList({ id: selectedQuizId }));
    }
    // dispatch(
    //   setState({
    //     key: "filteredUsersList",
    //     value: [],
    //   })
    // );
  };

  console.log(liveParticipantsList);

  // Common button style
  const btnStyle = {
    padding: "8px 16px",
    borderRadius: "6px",
    fontWeight: "500",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
  };
  function ReusableTable({ columns = [], rows = [] }) {
    if (!rows || rows.length === 0) {
      return (
        <p className="text-center text-gray-500 py-6 text-lg">
          No data available
        </p>
      );
    }

    return (
      <table className="table table-striped table-bordered text-15 w-full">
        <thead>
          <tr style={{ backgroundColor: "#e5e7eb", color: "#374151" }}>
            <th>Sl NO.</th>
            {columns.map((col, index) => (
              <th key={index} className="text-center px-4 py-2">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.id || rowIndex} className="hover:bg-gray-100">
              <td>{rowIndex + 1}</td>
              {columns.map((col, colIndex) => (
                <td key={colIndex} className="text-center px-4 py-2">
                  {/* If accessor function exists, use it, otherwise use key */}
                  {typeof col.accessor === "function"
                    ? col.accessor(row, rowIndex)
                    : row[col.key] ?? "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  const columns = [
    { key: "slno", label: "Slno." },
    { key: "id", label: "User Id" },
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "mobile_number", label: "Mobile Number" },
    { key: "schoolname", label: "School Name" },
    {
      key: "class_or_group",
      label: subFilterBy === 3 ? "Group" : "Class"
    },
    { key: "score", label: "Score" },
    { key: "total_time_taken_ms", label: "Time Taken (s)" },
  ];
  const columns_new = [
    { key: "user_id", label: "User Id" },
    { key: "admin_name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "contact_number", label: "Mobile Number" },
    { key: "school_name", label: "School Name" },

    // ⭐ Dynamic Label
    {
      key: subFilterBy === 4 ? "group_id" : "class_id",
      label: subFilterBy === 4 ? "Group" : "Class"
    },
    { key: "score", label: "Score" },
    {
      key: "total_time_taken_ms",
      label: "Time Taken (s)",
      render: (q) =>
        q.total_time_taken_ms
          ? (q.total_time_taken_ms / 1000).toFixed(2) + "s"
          : "-"
    },
  ];


  // const tableData = liveParticipantsList?.data?.map((q, index) => ({
  //   slno: index + 1, // add serial no. here
  //   id: q.user_id,
  //   name: q.name || "-",
  //   email: q.email || "-",
  //   mobile_number: q.mobile_number || "-",
  //   score: q.score || "-",
  //   position: q.position || "-",
  //   total_time_taken_ms:
  //     q.status !== "registered" && q.total_time_taken_ms
  //       ? (q.total_time_taken_ms / 1000).toFixed(2) + "s"
  //       : "-",
  //   status: q?.status || "-",
  // }));
  const tableData = Array.isArray(liveParticipantsList)
    ? liveParticipantsList.map((q, index) => ({
      slno: index + 1,
      id: q.user_id,
      name: q.admin_name || "-",
      email: q.email || "-",
      mobile_number: q.contact_number || "-",
      schoolname: q.school_name || "-",
      class_or_group:
        subFilterBy === 3
          ? q.group_id || "-"
          : q.class_id || "-",
      score: q.score || "-",
      total_time_taken_ms: q.total_time_taken_ms
        ? (q.total_time_taken_ms / 1000).toFixed(2) + "s"
        : "-",
      status: q.status || "-",
    }))
    : [];

    const practiceListProcessed = Array.isArray(practiceList)
  ? practiceList.map((q) => ({
      ...q,
      total_time_taken_ms: q.total_time_taken_ms
        ? (q.total_time_taken_ms / 1000).toFixed(2) + "s"
        : "-",
    }))
  : [];


  console.log("TABLE DATA:", tableData);
  console.log("FILTERED LIST:", filteredUsersList);

  return (
    <div>
      <div className="grid grid-cols-1 rounded-3 p-1 bg-white shadow gap-4 relative ">
        <div
          style={{
            marginTop: "2%",
            display: "flex",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          {[
            { id: 1, label: "General Users" },
            { id: 2, label: "Participants of Live Quiz" },
            { id: 3, label: "Participants of Practice Quiz" },
          ].map((tab) => {
            const isActive = option_selected === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                style={{
                  flex: 1,
                  padding: "10px 0",
                  borderRadius: "6px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backgroundColor: isActive ? "#007bff" : "#fff",
                  color: isActive ? "#fff" : "#007bff",
                  border: `2px solid ${isActive ? "#007bff" : "#007bff"}`,
                  boxShadow: isActive
                    ? "0px 4px 8px rgba(37, 99, 235, 0.4)"
                    : "none",
                }}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div
          className="table-responsive p-2 rounded-3"
          style={{ height: "60vh", overflow: "auto" }}
        >
          {/* General Users Table */}
          {option_selected === 1 ? (
            <table className="table table-auto table-striped table-bordered  w-full">
              <tbody>
                <tr style={{ backgroundColor: "#e5e7eb", color: "#374151" }}>
                  <th className="text-center">Sl No.</th>
                  <th className="text-center">Admin Name</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Mobile Number</th>
                  <th className="text-center">Account Type</th>
                  <th className="text-center">School Name</th>
                  <th className="text-center">Class</th>
                </tr>

                {/* {usersList?.schools?.length > 0 &&
                  usersList?.schools?.map((q,index) => (
                    <tr key={q.id} className="hover:bg-gray-100">
                      <td className="text-center">{q.id}</td>
                      <td className="text-center">{q.name}</td>
                      <td className="text-center">{q.email}</td>
                      <td className="text-center">{q.mobile_number || "-"}</td>
                      <td className="text-center">
                        {q.date_of_birth
                          ? new Date(q.date_of_birth).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          : "-"}
                      </td>
                      <td className="text-center">{q.college_name || "-"}</td>
                      <td className="text-center">
                        {q.college_roll_number || "-"}
                      </td>
                      <td className="text-center">{q.role || "-"}</td>
                      <td className="text-center">
                        {new Date(q.registered_at).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>
                    </tr> */}
                {usersList?.schools?.length > 0 &&
                  usersList?.schools?.map((q, index) => {

                    // Parse student_details (if not null)
                    let parsedStudent = null;
                    if (q.student_details) {
                      try {
                        parsedStudent = JSON.parse(q.student_details);
                      } catch (e) {
                        console.log("Invalid student_details JSON", e);
                      }
                    }

                    // Parse contact_number (if JSON string)
                    let parsedContact = q.contact_number;
                    try {
                      if (typeof q.contact_number === "string" && q.contact_number.startsWith("{")) {
                        parsedContact = JSON.parse(q.contact_number);
                      }
                    } catch (e) { }

                    return (
                      <tr key={index} className="hover:bg-gray-100">
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{q.admin_name || "-"}</td>
                        <td className="text-center">{q.email || "-"}</td>

                        {/* Mobile number */}
                        <td className="text-center">
                          {parsedContact?.contact_number || q.contact_number || "-"}
                        </td>

                        <td className="text-center">{q.account_type || q.role || "-"}</td>
                        <td className="text-center">{q.school_name || "-"}</td>

                        {/* CLASS field → from parsed student_details */}
                        <td className="text-center">
                          {parsedStudent?.student_class ||
                            parsedContact?.class || // fallback from contact_number json
                            "-"}
                        </td>
                      </tr>
                    );
                  })}

              </tbody>
            </table>
          ) : (
            <div>
              <label style={{ padding: "16px", color: "#4b5563" }}>
                {option_selected === 2
                  ? "Choose a live Quiz"
                  : "Choose a practice quiz"}
                :
                {option_selected === 2 && (
                  <div style={{ display: "flex", gap: "16px", marginLeft: "16px" }}>
                    <label>
                      <input
                        type="radio"
                        name="liveType"
                        value="1"
                        checked={subFilterBy === 1}
                        onChange={async () => {
                          dispatch(setState({ key: "subFilterBy", value: 1 }));
                          dispatch(setState({ key: "selectedQuizId", value: "" }));

                          await dispatch(getQuizzes(1)); // quiz_type = 2 = live academic
                        }}
                      />
                      &nbsp; Live Academic
                    </label>

                    <label>
                      <input
                        type="radio"
                        name="liveType"
                        value="3"
                        checked={subFilterBy === 3}
                        onChange={async () => {
                          dispatch(setState({ key: "subFilterBy", value: 3 }));
                          dispatch(setState({ key: "selectedQuizId", value: "" }));

                          await dispatch(getQuizzes(3)); // quiz_type = 4 = live thematic
                        }}
                      />
                      &nbsp; Live Thematic
                    </label>
                  </div>
                )}
                {option_selected === 3 && (
                  <div style={{ display: "flex", gap: "16px", marginLeft: "16px" }}>
                    <label>
                      <input
                        type="radio"
                        name="practiceType"
                        value="2"
                        checked={subFilterBy === 2}
                        onChange={async () => {
                          dispatch(setState({ key: "subFilterBy", value: 2 }));
                          dispatch(setState({ key: "selectedQuizId", value: "" }));

                          await dispatch(getQuizzes(2)); // practice academic
                        }}
                      />
                      &nbsp; Practice Academic
                    </label>

                    <label>
                      <input
                        type="radio"
                        name="practiceType"
                        value="4"
                        checked={subFilterBy === 4}
                        onChange={async () => {
                          dispatch(setState({ key: "subFilterBy", value: 4 }));
                          dispatch(setState({ key: "selectedQuizId", value: "" }));

                          await dispatch(getQuizzes(4)); // practice thematic
                        }}
                      />
                      &nbsp; Practice Thematic
                    </label>
                  </div>
                )}

                <select
                  className="form-input"
                  value={selectedQuizId}
                  onChange={async (e) => {
                    const { value } = e.target;
                    dispatch(
                      setState({
                        key: "selectedQuizId",
                        value: value,
                      })
                    );
                    // if (value && option_selected === 2) {
                    //   await dispatch(
                    //     getQuizStudents({
                    //       quiz_id: value,
                    //       // status: "",
                    //       // search: "",
                    //       limit: 100,
                    //       offset: 0,
                    //     })
                    //   );
                    // }
                    // if (value && option_selected === 3) {
                    //   await dispatch(
                    //     getQuizParticipantsOld({
                    //       quiz_id: value,
                    //     })
                    //   );
                    // }
                  }}
                >
                  <option value={""}>Select</option>
                  {quizzes
                    // .filter(
                    //   (e) =>
                    //     e.quiz_type ===
                    //     (option_selected === "live"
                    //       ? 1
                    //       : option_selected === "practice"
                    //       ? 2
                    //       : null)
                    // )
                    .map((quiz) => (
                      <option key={quiz.id} value={quiz.id}>
                        {quiz.title}
                      </option>
                    ))}{" "}
                </select>

              </label>
            </div>
          )}


          {Number(option_selected) === 2 &&
            selectedQuizId && (
              <div>
                <CommonTable
                  total={liveParticipantsList.total_count}
                  filteredCount={liveParticipantsList.filtered_count}
                  columns={columns}
                  data={tableData || []}
                  initialRowsPerPage={100}
                  searchableKeys={["name", "email", "mobile_number", "status"]}
                  fetchData={({ limit, offset }) =>
                    dispatch(
                      getQuizParticipantsOld({
                        quiz_id: selectedQuizId,
                        // status: "",
                        // search: "",
                        quiz_type: subFilterBy,
                        limit,
                        offset,
                      })
                    )
                  }
                />


                {/* Practice Quiz Participants */}

              </div>
            )}
            
          {option_selected === 3 &&
            selectedQuizId &&
            practiceList?.length > 0 && (
              <div>
                <ReusableTable
                  columns={columns_new}
                  rows={practiceListProcessed}
                />
              </div>
            )}
          {option_selected === 3 &&
            selectedQuizId &&
            practiceList?.length === 0 && (
              <p
                style={{ textAlign: "center", color: "red", fontSize: "16px" }}
              >
                No Data found
              </p>
            )}

        </div>
      </div>
    </div>
  );
}


